import { createEventClass } from 'seng-event';

export class VideoEvent extends createEventClass<object>()('CLICK_INTERACTION_CLICK') {}
